export default {
    DEFAULT: 'default',
    PRINT: 'print',
    DARK: 'dark'
};